export default (title) => {
  if (typeof window.tC.event.click_cta === "function") {
    window.tC.event.click_cta(this, {
      cta_name: title,
    });
  }
};
